module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "bread"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/fh.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "con"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("首页")]), _vm._v("-")], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/goods'
    }
  }, [_vm._v("出售大厅")]), _vm._v("-")], 1), _vm._v(" "), _c('li', {
    staticClass: "current"
  }, [_vm._v("详细资料")])])]), _vm._v(" "), _c('div', {
    staticClass: "sec"
  }, [_c('top', {
    attrs: {
      "title": '活动详情'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con",
    domProps: {
      "innerHTML": _vm._s(_vm.act_info.buy_info)
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sec"
  }, [_c('top', {
    attrs: {
      "title": '会员详细资料'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con"
  }, [_c('ul', {
    staticClass: "tw"
  }, [_c('li', {
    staticClass: "pic-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("会员账号")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.account))])]), _vm._v(" "), (_vm.act_info.sale_extend) ? [_c('li', {
    staticClass: "pic-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("VIP等级")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.vip_level))])]), _vm._v(" "), _c('li', {
    staticClass: "pic-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("电子等级")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.e_level))])]), _vm._v(" "), (_vm.config_info.finance_salary_status === '1') ? _c('li', {
    staticClass: "pic-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("电子晋级礼金")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("￥" + _vm._s(_vm.info.e_up_reward) + "元")])]) : _vm._e(), _vm._v(" "), (_vm.config_info.week_salary_status === '1') ? _c('li', {
    staticClass: "pic-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("电子周俸禄")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("￥" + _vm._s(_vm.info.e_week_reward) + "元")])]) : _vm._e(), _vm._v(" "), (_vm.config_info.month_salary_status === '1') ? _c('li', {
    staticClass: "pic-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("电子周月俸禄")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("￥" + _vm._s(_vm.info.e_month_reward) + "元")])]) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.act_info.sale_extend) ? [_c('li', {
    staticClass: "pic-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("等级")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.e_level) + "级")])]), _vm._v(" "), (_vm.config_info.finance_salary_status === '1') ? _c('li', {
    staticClass: "pic-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("等级礼金")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.e_level) + "级")])]) : _vm._e(), _vm._v(" "), (_vm.config_info.week_salary_status === '1') ? _c('li', {
    staticClass: "pic-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("周俸禄")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("￥" + _vm._s(_vm.info.e_week_reward) + "元")])]) : _vm._e(), _vm._v(" "), (_vm.config_info.month_salary_status === '1') ? _c('li', {
    staticClass: "pic-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("月俸禄")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("￥" + _vm._s(_vm.info.e_month_reward) + "元")])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "pic-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("一口价")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("￥" + _vm._s(_vm.info.sale_price) + "元")])]), _vm._v(" "), _c('li', {
    staticClass: "pic-text"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("发布时间")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.info.created_at * 1000)))])])], 2), _vm._v(" "), (_vm.userInfo) ? _c('div', {
    staticClass: "bar"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBtn),
      expression: "showBtn"
    }],
    staticClass: "btn",
    on: {
      "click": _vm.goBuy
    }
  }, [_vm._v("我要买")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBtn),
      expression: "showBtn"
    }],
    staticClass: "btn",
    on: {
      "click": _vm.goBid
    }
  }, [_vm._v("我要出价")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "tag": "button",
      "to": '/sell'
    }
  }, [_vm._v("我要卖")])], 1) : _c('div', {
    staticClass: "bar"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.showLogin
    }
  }, [_vm._v("我要买")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.showLogin
    }
  }, [_vm._v("我要出价")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.showLogin
    }
  }, [_vm._v("我要卖")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "sec"
  }, [_c('top', {
    attrs: {
      "title": '活动细则'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con",
    domProps: {
      "innerHTML": _vm._s(_vm.act_info.buy_rule)
    }
  })], 1), _vm._v(" "), (_vm.info) ? _c('el-dialog', {
    attrs: {
      "title": "我要出价",
      "visible": _vm.cjFormVisible,
      "custom-class": "dialog-t",
      "width": "890px"
    },
    on: {
      "update:visible": function($event) {
        _vm.cjFormVisible = $event
      }
    }
  }, [(_vm.userInfo) ? _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "input_text lef"
  }, [_c('span', {
    staticClass: "label lar"
  }, [_vm._v("账号ID")]), _vm._v(" "), _c('span', {
    staticClass: "static"
  }, [_vm._v(_vm._s(_vm.userInfo.username))])]), _vm._v(" "), _c('div', {
    staticClass: "input_text lef"
  }, [_c('span', {
    staticClass: "label lar"
  }, [_vm._v("您想购买的账号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.account),
      expression: "info.account"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.info.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "account", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input_text lef"
  }, [_c('span', {
    staticClass: "label lar"
  }, [_vm._v("您的出价")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cj_form.price),
      expression: "cj_form.price"
    }],
    staticClass: "text",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cj_form.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cj_form, "price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input_text lef"
  }, [_c('span', {
    staticClass: "label lar"
  }, [_vm._v("其他")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cj_form.others),
      expression: "cj_form.others"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.cj_form.others)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cj_form, "others", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitBid
    }
  }, [_vm._v("确认提交")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.userInfo) ? _c('buy-dialog', {
    ref: "buyDialog",
    attrs: {
      "info": _vm.info,
      "tel": _vm.act_info.service_buy
    },
    on: {
      "submitbuy": _vm.submitBuy
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bf11a32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/detail.vue
// module id = 636
// module chunks = 31